import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Form, Row, Col, Input } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';

const SubgroupForm = ({ form }) => {
  const intl = useIntl();

  const defaultEmptyFieldError = {
    required: true,
    message: intl.formatMessage({
      id: 'commons.form.errors.requiredField',
    }),
  };

  return (
    <Form form={form}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FloatingFormItem
            name="name"
            rules={[defaultEmptyFieldError]}
            label={intl.formatMessage({
              id: 'groups.general.form.description',
            })}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default SubgroupForm;
